import React from "react";
import styles from "./Modal.module.scss";
import Loading from "../Loading";
import classNames from "classnames";

export default function Modal({
  job,
  name,
  email,
  applyName,
  portfolioName,
  link,
  phoneNumber,
  setIsModal,
  onSubmit,
  isDarkMode,
  isLoading,
  width,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.modalContainer}>
        <section className={styles.modal_header}>
          <p className={classNames({ "title-kr-M": true })}>
            {job?.lo === "en" ? "Check support details" : "지원 내용 확인"}
          </p>
        </section>
        <section className={styles.modal_title}>
          <span>
            <p
              className={classNames(styles.modal_duty, { "title-kr-XL": true })}
            >
              {job?.team}&nbsp; {job?.duty}
            </p>
          </span>

          <p className={classNames(styles.modal_type, { "label-kr-M": true })}>
            {job?.type}
          </p>
        </section>
        <section className={styles.applyInfo}>
          <p
            className={classNames(styles.applyInfo_title, {
              "title-kr-L": true,
            })}
          >
            {job?.lo === "en" ? "Personal Information" : "인적 사항"}
          </p>
          <section className={styles.applyInfo_personal_info}>
            <div className={styles.applyInfo_personal_info_name}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "Name" : "이름"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>{name}</p>
            </div>
            <div className={styles.applyInfo_personal_info_number}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "Contact information" : "전화번호"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>{phoneNumber}</p>
            </div>
            <div className={styles.applyInfo_personal_info_email}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "E-mail" : "이메일"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>{email}</p>
            </div>
          </section>
        </section>
        <section className={styles.paperInfo}>
          <p
            className={classNames(styles.paperInfo_title, {
              "title-kr-L": true,
            })}
          >
            {job?.lo === "en" ? "Submitted Documents" : "제출 서류"}
          </p>
          <section className={styles.paperInfo_documents_info}>
            <div className={styles.paperInfo_documents_info_file}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "Resume, Cover letter" : "이력서"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>{applyName}</p>
            </div>
            <div className={styles.paperInfo_documents_info_additional_file}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "Portfolio(Optional)" : "추가 제출 서류"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>
                {portfolioName}
              </p>
            </div>
            <div className={styles.paperInfo_documents_info_link}>
              <p className={classNames({ "title-kr-M": true })}>
                {job?.lo === "en" ? "Additional Link (Optional)" : "링크"}
              </p>
              <p className={classNames({ "body-kr-M": true })}>{link}</p>
            </div>
          </section>
        </section>

        <section className={styles.submit_btn_container}>
          <p className={classNames({ "label-kr-L": true })}>
            {job?.lo === "en"
              ? "Would you like to submit your application?"
              : "지원서를 제출하시겠습니까?"}
          </p>
          <div className={styles.submit_btns}>
            <button
              onClick={onSubmit}
              className={classNames(styles.submit_btns_submit, {
                "red-medium-button": true,
                "label-kr-M": true,
              })}
            >
              {!isLoading ? (
                job?.lo === "en" ? (
                  "Submit"
                ) : (
                  "지원서 제출하기"
                )
              ) : (
                <Loading color={"white"} width={"20px"} height={"20px"} />
              )}
            </button>

            <button
              onClick={() => setIsModal(false)}
              className={classNames(styles.submit_btns_back, {
                "white-line-medium-button": true,
                "label-kr-M": true,
              })}
              disabled={!isLoading ? false : true}
            >
              {job?.lo === "en" ? "Edit" : "수정하기"}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
